export default "__VITE_ASSET__DtO$_ems__"